import { render, staticRenderFns } from "./WastedVisitCard.vue?vue&type=template&id=44a67314"
import script from "./WastedVisitCard.vue?vue&type=script&lang=js"
export * from "./WastedVisitCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports